<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    first_btn="Catalog.Send"
    :loading="loading"
    :title="$t('Tenders.ResendInvitationsTitle')"
    @apply="submit "
    @close="close">
    <template #activator-btn>
      <v-tooltip
        v-model="tooltip"
        bottom
        content-class="tooltip black--text"
        open-delay="100">
        <template #activator="{ on }">
          <div v-on="on">
            <sButton
              :disabled="!tender.resendInvitationsAvailable"
              icon="repeat"
              small
              type="text"
              @click="openDialog"/>
          </div>
        </template>
        <div>
          {{ !tender.resendInvitationsAvailable || invitations.length ?
            $t('Tenders.ResendingInvitationsCompleted') :
            $t('Tenders.ResendInvitations') }}
        </div>

        <v-skeleton-loader
          v-if="load_dates"
          type="text"
          width="80%"/>
        <div
          v-for="(item, index) in invitations"
          :key="item + '' + index"
          class="text-start">
          {{ item }}
        </div>
      </v-tooltip>
    </template>
    <template #card-text>
      <v-row>
        <v-col class="col-9 py-0">
          <v-card-text
            class="px-0">
            {{ $t('Tenders.ResendInvitationFunction') }}
            <div class="last_invitation">
              {{ last_invitation }}
            </div>
          </v-card-text>
        </v-col>
      </v-row>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
import moment from 'moment'

const api = new SmarttenderApi()
export default {
  name: 'resendInvitations',
  data() {
    return {
      dialog: false,
      success: false,
      loading: false,
      tooltip: false,
      load_dates: false,
      loaded_dates: false,
      resended_dates: []
    }
  },
  props: {
    tender: Object
  },
  computed: {
    last_invitation() {
      if ( this.resended_dates?.length ) {
        return this.$t('Tenders.FirstResendInvitationsPerformed') + ' ' + moment(this.resended_dates[0]).format('DD.MM.YYYY HH:mm')
      }
      return ''
    },
    invitations() {
      if ( this.resended_dates?.length ) {
        return  this.resended_dates.map(date => moment(date).format('DD.MM.YYYY HH:mm') )
      }
      return ''
    },
  },
  methods: {
    async submit() {
      this.loading = true
      await api.resentRequestToParticipants(this.tender.tenderId)
        .then(res => {
          if (res.data?.resentRequestToParticipants) {
            this.resended_dates.push(moment().format('YYYY-MM-DDTHH:mm:ss'))
            if ( this.resended_dates?.length > 1 ) {
              // eslint-disable-next-line vue/no-mutating-props
              this.tender.resendInvitationsAvailable = false
            }

            this.dialog = false
            this.$Modal.info({
              title: this.$t('Tenders.ResentSuccessfully'),
              closable: true,
              okText: this.$t('Common.Clearly'),
              onOk: () => {
                this.close()
              },
              width: 736

            })
          }
        })
      this.loading = false
    },
    openDialog() {
      this.dialog = true
      this.getResendedDates()
    },
    close() {
      this.dialog = false
    },
    async getResendedDates() {
      if ( !this.resended_dates?.length && !this.loaded_dates) {
        this.load_dates = true
        await api.resendInvitations(this.tender.tenderId)
          .then(res => {
            this.resended_dates = res || []
            this.loaded_dates = true
          })
        this.load_dates = false
      }
    }
  },
  watch: {
    tooltip(val) {
      if ( val ) {
        this.getResendedDates()
      }
    }
  },
  components: {
    DialogTemplateToolkit
  }
}
</script>
